module.exports = __webpack_public_path__ + "img/avatar-answer.979fe449.png";